
export function getUrlForPhoto(propertyId: string, docName: string) {
    return `https://property-uploader-us-west-1.s3.us-west-1.amazonaws.com/${propertyId.split('_')[1]}/${docName}`
}